<script>
export default {
    name: 'IconClock'
}
</script>
<template>
    <svg
        class="base-icon icon-clock"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm0-42c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zm2 4h-4v14h.047l-.047.04 7.713 9.193 3.065-2.571L34 30.584V18z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
